import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import {auth, signInWithGoogle} from '../../firebase';
import {Button, Container, makeStyles, MobileStepper, Paper, TextField, Typography} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    },
    paper: {
        padding: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Ширина формы
        marginTop: theme.spacing(1),
    },
    submit: {
        marginTop: theme.spacing(2),
    },
}));

const Signup = () => {
    const navigate = useNavigate();
    const classes = useStyles();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();

        await createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Успешная регистрация
                const user = userCredential.user;
                console.log(user);
                navigate('/');
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.error(errorCode, errorMessage);
            });
    };

    const handleSignInWithGoogle = async () => {
        try {
            await signInWithGoogle();
            // Вход с помощью Google выполнен успешно
            navigate('/home');
        } catch (error) {
            // Обработка ошибки, если вход не выполнен
            console.error('Error signing in with Google:', error);
        }
    };

    return (
        <div className={classes.root}>
            <Container component="main" maxWidth="xs">
                <Paper className={classes.paper}>
                    <Typography component="h1" variant="h5">
                        ResearchAI
                    </Typography>
                    <form className={classes.form}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={onSubmit}
                        >
                            Sign up
                        </Button>
                    </form>
                    <Button
                        fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={handleSignInWithGoogle}
                    >
                        Sign up with google
                    </Button>
                    <Typography variant="body2">
                        Already have an account?{' '}
                        <NavLink to="/">Sign in</NavLink>
                    </Typography>
                </Paper>
            </Container>
        </div>
    );
};

export default Signup;
